import { useState, useCallback } from 'react'
import { RefreshCwIcon, IconButton } from '@buffer-mono/popcorn'
import styles from './RefreshButton.module.css'

type Props = {
  refresh: () => Promise<void>
}
export const RefreshButton = ({ refresh }: Props): JSX.Element => {
  const [isRefreshing, setIsRefreshing] = useState(false)
  const handleRefresh = useCallback(async (): Promise<void> => {
    setIsRefreshing(true)
    try {
      await refresh()
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
    } finally {
      setIsRefreshing(false)
    }
  }, [refresh])

  return (
    <IconButton
      variant="tertiary"
      size="small"
      label="Refresh"
      disabled={isRefreshing}
      onClick={(): void => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handleRefresh()
      }}
    >
      <RefreshCwIcon className={isRefreshing ? styles.isRefreshing : ''} />
    </IconButton>
  )
}
